/**
 * BC Premium Product — Brilliance Cosmocare
 * Vanilla JS, no jQuery
 */
(function () {
  'use strict';

  /* ---- Dynamic Shoppers Counter (with weekly compounding) ---- */
  function initShoppersCounter(section) {
    var box = section.querySelector('[data-shoppers-counter]');
    if (!box) return;
    var el = box.querySelector('[data-shoppers-count]');
    var resetBtn = box.querySelector('[data-shoppers-reset]');
    if (!el) return;

    var minBase = parseInt(box.getAttribute('data-week-base-min'), 10) || 500;
    var maxBase = parseInt(box.getAttribute('data-week-base-max'), 10) || 1000;
    var growthPct = parseFloat(box.getAttribute('data-week-growth')) || 50;
    var resetToken = box.getAttribute('data-reset-token') || '1';
    var sectionId = section.getAttribute('data-section-id') || 'default';
    var storageKey = 'bc_shoppers_' + sectionId;

    var WEEK_MS = 7 * 24 * 60 * 60 * 1000;
    var growthMultiplier = 1 + (growthPct / 100); // 1.5 for 50%

    // ---- State management ----
    function loadState() {
      try {
        var raw = localStorage.getItem(storageKey);
        if (!raw) return null;
        var s = JSON.parse(raw);
        if (s.token !== resetToken) return null; // admin reset triggered
        return s;
      } catch (e) { return null; }
    }

    function saveState(state) {
      try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (e) {}
    }

    function getOrInitAnchor() {
      var state = loadState();
      if (state && state.anchor) return state.anchor;
      var anchor = Date.now();
      saveState({ token: resetToken, anchor: anchor });
      return anchor;
    }

    function currentWeek() {
      var anchor = getOrInitAnchor();
      var weeks = Math.floor((Date.now() - anchor) / WEEK_MS);
      return weeks + 1; // Week 1 starts at anchor
    }

    function currentRange() {
      var week = currentWeek();
      var factor = Math.pow(growthMultiplier, week - 1);
      var min = Math.round(minBase * factor);
      var max = Math.round(maxBase * factor);
      return { min: min, max: max, week: week };
    }

    // ---- Random number generator (uses Date.now() + Math.random() for variability) ----
    // This produces effectively unlimited unique numbers in the range
    function randomInRange(min, max) {
      var span = max - min + 1;
      var rand = Math.floor(Math.random() * span);
      return min + rand;
    }

    function formatNumber(n) {
      // Add comma separator for 1000+
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function tick() {
      var range = currentRange();
      var n = randomInRange(range.min, range.max);
      el.textContent = formatNumber(n);
    }

    function scheduleNext() {
      var delay = Math.floor(Math.random() * 7000) + 8000; // 8-15s
      setTimeout(function () {
        tick();
        scheduleNext();
      }, delay);
    }

    // ---- Reset functionality ----
    function resetCounter() {
      try { localStorage.removeItem(storageKey); } catch (e) {}
      getOrInitAnchor(); // reinitialize with current date
      tick();
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        resetCounter();
      });

      // ---- Visibility logic for reset button ----
      // Show only when: (a) Shopify designMode (admin in Customizer) OR (b) URL has ?bc_admin=1
      var isAdmin = (window.Shopify && window.Shopify.designMode) ||
                    (window.location.search.indexOf('bc_admin=1') !== -1);
      if (!isAdmin) {
        resetBtn.style.display = 'none';
      }
    }

    // Initial render + schedule
    tick();
    scheduleNext();
  }

  function initSection(section) {
    if (!section || section.dataset.bchInit === '1') return;
    section.dataset.bchInit = '1';

    initThumbnails(section);
    initThumbsCarousel(section);
    initFavorite(section);
    initShare(section);
    initQuantity(section);
    initConcerns(section);
    initResultsScroll(section);
    initReelsScroll(section);
    initCaseModal(section);
    initReelModal(section);
    initReviewsModal(section);
    initAtcForm(section);
    initBuyNow(section);
    initShoppersCounter(section);
  }

  /* ---- Thumbnail carousel arrows ---- */
  function initThumbsCarousel(section) {
    var track = section.querySelector('[data-thumbs-track]');
    if (!track) return;
    var prev = section.querySelector('[data-thumbs-prev]');
    var next = section.querySelector('[data-thumbs-next]');

    function scrollAmount() {
      // Roughly 3 thumbs worth
      return 280;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  }

  /* ---- Thumbnail → main image ---- */
  function initThumbnails(section) {
    var main = section.querySelector('[data-main-image]');
    var thumbs = section.querySelectorAll('[data-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-thumb-full');
        if (!src) return;

        // IMPORTANT: Must remove srcset first.
        // Browsers prioritise srcset over src, so setting src alone
        // has no visible effect when srcset is present.
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.setAttribute('src', src);

        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---- Favorite heart toggle ---- */
  function initFavorite(section) {
    var btn = section.querySelector('[data-favorite]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      btn.classList.toggle('is-active');
      showToast(section, btn.classList.contains('is-active') ? 'Saved to your wishlist' : 'Removed from wishlist');
    });
  }

  /* ---- Share button ---- */
  function initShare(section) {
    var btn = section.querySelector('[data-share]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      try {
        navigator.clipboard.writeText(window.location.href);
        showToast(section, 'Product link copied to clipboard!');
      } catch (e) {}
    });
  }

  /* ---- Quantity selector ---- */
  function initQuantity(section) {
    var qty = section.querySelector('[data-qty]');
    if (!qty) return;
    var input = qty.querySelector('input[name="quantity"]');
    var display = qty.querySelector('[data-qty-display]');
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    var atcPrice = section.querySelector('[data-atc-price]');
    var unitPrice = parseFloat(section.getAttribute('data-unit-price') || '0');
    var currency = section.getAttribute('data-currency') || 'Rs.';

    function sync() {
      var v = parseInt(input.value, 10) || 1;
      if (display) display.textContent = v;
      if (atcPrice && unitPrice > 0) {
        var total = (unitPrice * v).toFixed(2);
        atcPrice.textContent = currency + ' ' + total;
      }
    }

    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
      sync();
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
      sync();
    });
    sync();
  }

  /* ---- Concerns toggle ---- */
  function initConcerns(section) {
    var btns = section.querySelectorAll('[data-concern]');
    var tray = section.querySelector('[data-concern-tray]');
    var trayTitle = section.querySelector('[data-concern-tray-title]');
    var trayText = section.querySelector('[data-concern-tray-text]');
    var closeBtn = section.querySelector('[data-concern-close]');

    function close() {
      if (tray) tray.setAttribute('hidden', '');
      btns.forEach(function (b) { b.classList.remove('is-active'); });
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wasActive = btn.classList.contains('is-active');
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        if (wasActive) {
          close();
        } else {
          btn.classList.add('is-active');
          if (tray && trayTitle && trayText) {
            trayTitle.textContent = btn.getAttribute('data-concern-title') || '';
            trayText.textContent = btn.getAttribute('data-concern-details') || '';
            tray.removeAttribute('hidden');
          }
        }
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
  }

  /* ---- Horizontal scrollers ---- */
  function initResultsScroll(section) {
    var track = section.querySelector('[data-results-track]');
    if (!track) return;
    var prev = section.querySelector('[data-results-prev]');
    var next = section.querySelector('[data-results-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -260, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: 260, behavior: 'smooth' }); });
  }

  function initReelsScroll(section) {
    var track = section.querySelector('[data-reels-track]');
    if (!track) return;
    var prev = section.querySelector('[data-reels-prev]');
    var next = section.querySelector('[data-reels-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -140, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: 140, behavior: 'smooth' }); });
  }

  /* ---- Case (result) modal ---- */
  function initCaseModal(section) {
    var modal = section.querySelector('[data-case-modal]');
    if (!modal) return;
    var imgEl = modal.querySelector('[data-case-img]');
    var timelineEl = modal.querySelector('[data-case-timeline]');
    var titleEl = modal.querySelector('[data-case-title]');
    var locEl = modal.querySelector('[data-case-loc]');
    var concernEl = modal.querySelector('[data-case-concern]');
    var closeBtns = modal.querySelectorAll('[data-case-close]');
    var bg = modal.querySelector('.bch-case-modal__bg');

    function open(data) {
      if (imgEl) imgEl.src = data.img || '';
      if (timelineEl) timelineEl.textContent = data.timeline || '';
      if (titleEl) titleEl.textContent = data.title || '';
      if (locEl) locEl.textContent = data.location || '';
      if (concernEl) concernEl.textContent = data.concern || '';
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    section.querySelectorAll('[data-case-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open({
          img: btn.getAttribute('data-case-img'),
          timeline: btn.getAttribute('data-case-timeline'),
          title: btn.getAttribute('data-case-title'),
          location: btn.getAttribute('data-case-location'),
          concern: btn.getAttribute('data-case-concern')
        });
      });
    });

    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    if (bg) bg.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ---- Reel video modal ---- */
  function initReelModal(section) {
    var modal = section.querySelector('[data-reel-modal]');
    if (!modal) return;
    var video = modal.querySelector('[data-reel-video]');
    var captionTitle = modal.querySelector('[data-reel-caption-title]');
    var captionText = modal.querySelector('[data-reel-caption-text]');
    var closeBtns = modal.querySelectorAll('[data-reel-close]');
    var bg = modal.querySelector('.bch-reel-modal__bg');

    function open(data) {
      if (!data.video || !video) return;
      video.src = data.video;
      if (captionTitle) captionTitle.textContent = (data.name || '') + ' • ' + (data.timeline || '');
      if (captionText) captionText.textContent = '"' + (data.caption || '') + '"';
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      try { video.play(); } catch (e) {}
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (video) {
        try { video.pause(); } catch (e) {}
        video.removeAttribute('src');
        video.load();
      }
    }

    section.querySelectorAll('[data-reel-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open({
          video: btn.getAttribute('data-reel-video-url'),
          name: btn.getAttribute('data-reel-name'),
          timeline: btn.getAttribute('data-reel-timeline'),
          caption: btn.getAttribute('data-reel-caption')
        });
      });
    });

    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    if (bg) bg.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ---- Reviews modal ---- */
  function initReviewsModal(section) {
    var modal = section.querySelector('[data-reviews-modal]');
    if (!modal) return;
    var openBtn = section.querySelector('[data-reviews-open]');
    var closeBtns = modal.querySelectorAll('[data-reviews-close]');
    var bg = modal.querySelector('.bch-reviews-modal__bg');

    function open() {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', open);
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    if (bg) bg.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ---- ATC form ---- */
  function initAtcForm(section) {
    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // If theme has product-form custom element, defer to it
    if (window.customElements && window.customElements.get('product-form')) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = section.querySelector('[data-atc]');
      var errWrap = section.querySelector('[data-form-error]');
      var errMsg = errWrap ? errWrap.querySelector('span') : null;

      if (btn) {
        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', 'true');
      }
      if (errWrap) errWrap.setAttribute('hidden', '');

      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.body && (res.body.description || res.body.message)) || 'Could not add to cart.';
            if (errWrap && errMsg) { errMsg.textContent = msg; errWrap.removeAttribute('hidden'); }
            return;
          }
          if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bch-form' });
          }
          var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(res.body);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          if (errWrap && errMsg) {
            errMsg.textContent = 'Something went wrong. Please try again.';
            errWrap.removeAttribute('hidden');
          }
        })
        .finally(function () {
          if (btn) {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
          }
        });
    });
  }

  /* ---- Buy Now ---- */
  function initBuyNow(section) {
    var btn = section.querySelector('[data-buy-now]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var idInput = section.querySelector('input[name="id"]');
      var qtyInput = section.querySelector('input[name="quantity"]');
      if (!idInput) return;
      var id = idInput.value;
      var qty = qtyInput ? qtyInput.value : 1;
      window.location.href = '/cart/' + id + ':' + qty + '?checkout';
    });
  }

  /* ---- Toast ---- */
  function showToast(section, message) {
    var toast = section.querySelector('[data-toast]');
    if (!toast) return;
    var msgEl = toast.querySelector('[data-toast-msg]');
    if (msgEl) msgEl.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3000);
  }

  /* ---- Boot ---- */
  function boot() {
    document.querySelectorAll('.bch-hero').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector('.bch-hero');
      if (sec) initSection(sec);
    });
  }
})();